import { render } from "./PaymentSection.vue?vue&type=template&id=6387c70b"
import script from "./PaymentSection.vue?vue&type=script&lang=js"
export * from "./PaymentSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__